import * as CD from 'app/cd/models/essette-api';
import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ProviderService } from 'app/cd/services/provider-service';
import { apiCall } from 'app/shared/lib/api/api';


@autoinject()
export class ProviderInformationCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public providerId: string | null = null;

    protected provider: CD.Provider | null = null;

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly providerService: ProviderService,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        this.loadProvider();
    }


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadProvider(): Promise<void> {
        if(!this.providerId) return;

        const includes: string[] = [
            'type',
            'gender',
            'language.reads',
            'language.speaks',
            'custom.target.definitions'
        ];

        try {
            this.state.beginLoad();

            const response = await this.providerService.loadProvider(this.providerId, includes);
            this.provider = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
